import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete as AutocompleteMui } from '@material-ui/lab';

export type { IOptions } from './interfaces';
import { IAutocomplete, IOptions } from './interfaces';

export const Autocomplete = (props: IAutocomplete) => {
  const {
    onChange,
    objects: objectsProps,
    objectKey,
    objectValue,
    label,
    loading,
    disabled,
    defaultValue,
    showObjectKey,
    variant
  } = props;

  const [value, setValue] = useState<IOptions | null>(null);
  const options: IOptions[] = [];
  const objects = objectsProps || [];

  objects.forEach((object) => {
    if (objectKey && objectValue) {
      options.push({ key: object[objectKey], value: object[objectValue] });
    }
  });

  useEffect(() => {
    if (defaultValue && value === null) {
      const defaultOption = options.find((option) => option.key === defaultValue);
      if (defaultOption) {
        setValue(defaultOption);
      }
    }
  }, [defaultValue, options, value]);

  const handleChange = (_: any, value: IOptions | null) => {
    setValue(value);

    if (value !== null) {
      onChange(value);
    } else {
      setValue(null);
      onChange({ key: '', value: '' });
    }
  };

  return (
    <AutocompleteMui
      loading={loading}
      options={options}
      disabled={disabled}
      getOptionLabel={(option: IOptions): string => (showObjectKey ? `${option.key} - ${option.value}` : option.value)}
      getOptionSelected={(option, value) => option.value === value.value}
      onChange={handleChange}
      loadingText="Carregando..."
      noOptionsText="Sem opções"
      value={value}
      renderInput={(params) => <TextField {...params} variant={variant || 'standard'} label={label} fullWidth />}
    />
  );
};
